function getClassName(index) {
  let parameters = {};
  switch (index) {
    case 0:
      parameters = { className: 'card_1', width: 200, height: 300 };
      break;
    case 3:
      parameters = { className: 'card_4', width: 420, height: 300 };
      break;
    case 7:
      parameters = { className: 'card_8', width: 200, height: 300 };
      break;
    case 8:
      parameters = { className: 'card_9', width: 420, height: 300 };
      break;
    case 10:
      parameters = { className: 'card_11', width: 200, height: 300 };
      break;
    case 14:
      parameters = { className: 'card_14', width: 420, height: 300 };
      break;
    case 17:
      parameters = { className: 'card_18', width: 200, height: 300 };
      break;
    case 18:
      parameters = { className: 'card_19', width: 420, height: 300 };
      break;

    default:
      parameters = { className: 'card', width: 200, height: 140 };
  }
  return parameters;
}

export { getClassName };
